import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedSection() {
  const featured = articles.filter((item) => item.featured);
  const lead = featured[0];
  const hotList = articles
    .slice()
    .sort((a, b) => b.views - a.views)
    .slice(0, 4);

  return (
    <section id="featured" className="border-y border-background-200 bg-background-100/50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">EDITOR'S PICKS</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">编辑精选</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            挑出结构最完整、可核对点最多的几篇，适合第一次来的读者从这几篇开始看。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:mt-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            {lead ? <ArticleCard article={lead} variant="wide" /> : null}
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-fire-line text-sm"></i>
              </span>
              本周热读榜
            </h3>
            <div className="mt-3">
              {hotList.map((item, index) => (
                <ArticleCard key={item.id} article={item} variant="compact" index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}